import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { CalendarEvent } from 'src/meetings/models';

export const useLinkNewClientToParticipant = (eventId: string) => {
  const queryClient = useQueryClient();

  return useMutation<{ data: CalendarEvent }, Error, { participantId: string; clientId: string }>({
    mutationFn: ({ participantId, clientId }) =>
      api.post<CalendarEvent>(
        `calendar-events/${eventId}/participants/${participantId}/link-new-client`,
        { clientId },
      ),
    onSuccess: async ({ data }) => {
      const queryKey = ['calendar-events', eventId];
      await queryClient.cancelQueries({ queryKey });
      queryClient.setQueryData(queryKey, data);
      void queryClient.invalidateQueries({ queryKey });
    },
  });
};
